import React from "react";
import EmptyPage from "../../components/EmptyPage";

const Roles = () => {
  return (
    <EmptyPage
      title="Roles & Permissions"
      description="Configure user roles, set permissions, and manage access levels for different features and data within your real estate platform."
      icon="🔐"
    />
  );
};

export default Roles;
